<template>
    <div class="min-h-full w-full bg-white">
        <div class="mx-auto w-full max-w-screen-2xl pb-40 px-8">
            <template v-if="state==='loading'">
                <div class="flex mt-4">
                    Loading Resource Planning Report Data...
                </div>
            </template>
            <template v-else-if="state==='noPlan'">
                <div class="flex mt-4">
                    No Resource Planning Report Data found!
                </div>
            </template>
            <template v-else>
                <div class="flex space-x-2">
                    <div class="flex-1">
                        <div class="sticky top-0 bg-white px-0 mb-2 z-30">
                            <!-- Some Tabs. -->
                            <div class="flex flex-1 pt-4">
                                <div class="flex-1">
                                    <div
                                        class="text-2xl font-bold text-gray-900 border-transparent rounded shadow-none px-2 py-1 -ml-2.5 mb-0">
                                        Resource Planning Report
                                    </div>

                                    <div class="text-sm text-gray-500">
                                        STATUS • Reference #BLAS
                                        <span>• Revision 35</span>
                                    </div>
                                </div>
                                <div class="pt-3">
                                    <div @click="mode='materials'"
                                         class="inline-block m-1 border-0 shadow-none px-3 py-2 font-medium text-sm rounded-md focus:z-20 focus:outline-none "
                                         style="min-width: 20px;cursor: pointer"
                                         :class="mode==='materials'?'bg-blue-100 text-blue-700 focus:ring-2 focus:ring-blue-600':''"
                                    >Materials
                                    </div>
                                    <div @click="mode='budgets'"
                                         class="inline-block m-1 border-0 shadow-none px-3 py-2 font-medium text-sm rounded-md focus:z-20 focus:outline-none "
                                         style="min-width: 20px;cursor: pointer"
                                         :class="mode==='budgets'?'bg-blue-100 text-blue-700 focus:ring-2 focus:ring-blue-600':''"
                                    >Budgets
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="px-0 py-2 rounded-lg" v-if="mode==='materials'">
                            <div class="w-full mb-1 text-lg flex">
                                <div class="flex-1 flex-grow">Sections:</div>
                                <ui-toggle class="inline-block w-auto p-0.5 rounded-xl mr-8" field="text-xs"
                                           v-model="split.sections"
                                           :text="`Split Sections`"
                                           :field="'text-gray-900'"
                                ></ui-toggle>
                            </div>
                            <div v-if="split.sections">
                                <resource-planning-report-material-sections :sections="resourcePlanningReport.sections"
                                                                            :split="split">
                                </resource-planning-report-material-sections>
                            </div>
                            <div v-else>
                                <div
                                    class="flex mt-2 border-t border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold">
                                    <div class="flex-1 border-r border-l border-gray-200 px-2 py-1 -ml-px">Material
                                    </div>
                                    <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px">UoM</div>
                                    <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">Total Required
                                    </div>
                                    <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">Requested</div>
                                    <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">Ordered
                                    </div>
                                    <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">Received</div>
                                    <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">Still
                                        Required
                                    </div>
                                </div>
                                <resource-planning-report-material-item
                                    v-for="(material,index) in resourcePlanningReport.materials" :item="material"
                                    :key="index">
                                </resource-planning-report-material-item>
                            </div>
                            <div class="py-4" v-if="resourcePlanningReport.unreconciledMaterialItems && resourcePlanningReport.unreconciledMaterialItems.length">
                                <div class="w-full mb-1 text-lg flex">
                                    <div class="flex-1 flex-grow">Unreconciled Materials:</div>
                                </div>
                                <div
                                    class="flex mt-2 border-t border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold">
                                    <div class="flex-1 border-r border-l border-gray-200 px-2 py-1 -ml-px">Material
                                    </div>
                                    <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px">UoM</div>
                                    <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">Total Required
                                    </div>
                                    <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">Requested</div>
                                    <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">Ordered
                                    </div>
                                    <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">Received</div>
                                    <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">Still
                                        Required
                                    </div>
                                </div>
                                <resource-planning-report-material-item
                                    v-for="(material,index) in resourcePlanningReport.unreconciledMaterialItems" :item="material"
                                    :key="'un'+index">
                                </resource-planning-report-material-item>
                            </div>
                        </div>
                        <div class="pb-6 pt-2" v-if="mode==='budgets'">
                            <resource-planning-report-budgets
                                :resource-planning-report="resourcePlanningReport"></resource-planning-report-budgets>
                        </div>
                    </div>
                    <div class="w-72 space-y-8 relative pt-4">
                        <div class="w-72 space-y-1 fixed">
                            <div
                                style="overflow-y: auto; padding-right:12px; margin-top:12px; padding-top:12px; top:0px; height:calc(100vh - 250px)">
                                <resource-planning-report-settings-panel :show-omitted="showOmitted"
                                                                         @toggleShowOmittedState="(i) => showOmitted = i"
                                ></resource-planning-report-settings-panel>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>

import UiToggle from "../ui/UiToggle.vue";
import {resolveNumericText} from "../../utils";
import {ResourcePlanningReport} from "@models";
import ResourcePlanningReportMaterialItem from "./ResourcePlanningReportMaterialItem.vue";
import ResourcePlanningReportBudget from "./ResourcePlanningReportBudget.vue";
import ResourcePlanningReportBudgets from "./ResourcePlanningReportBudgets.vue";

export default {
    components: {
        ResourcePlanningReportBudgets,
        ResourcePlanningReportBudget,
        ResourcePlanningReportMaterialItem,
        UiToggle,
    },
    props: {
        id: String,
        packageReference: String
    },
    data() {
        return {
            resourcePlanningReport: null,
            showOmitted: false,
            resolveNumericText,
            state: 'loading',
            mode: 'materials',
            split: {
                sections: false,
                tasks: false,
                items: false,
            },
            breakdown: {
                materials: false,
                labour: true,
                fixedCosts: false,
            }
        };
    },
    computed: {},
    methods: {
        async updateLatest() {
            try {
                this.resourcePlanningReport = await ResourcePlanningReport.find(this.packageReference);
            } catch (e) {
            }
        },
        toggle() {

        },
    },
    async mounted() {
        await this.updateLatest();
        if (this.resourcePlanningReport) {
            this.state = "loaded"
        } else {
            this.state = "noPlan"
        }
        $("#app-content").css("padding", 0);
    }
};
</script>
